import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { myTaskService } from 'services';

const initialState = {
  data: {},
  detailApproval: {},
  statusList: 'idle',
  statusDetail: '',
  statusSubmit: '',
  dataTaskList : '',
  statusTaskList: '',
  statusAssignee: '',
  dataUserList: {},
  statusUserList: '',
};

export const getList = createAsyncThunk(
  'apprv_maintenance/fetchlist',
  async (data) => {
    const response = await myTaskService.list(data);
    return response;
  }
);

export const getDetail = createAsyncThunk(
  'apprv_maintenance/fetchById',
  async (data) => {
    const response = await myTaskService.show(data);
    return response;
  }
);

export const submitTask = createAsyncThunk(
  'apprv_maintenance/fetchSubmit',
  async (data) => {
    const response = await myTaskService.taskAction(data);
    return response;
  }
);

export const getListTask = createAsyncThunk('task_routing/fetchlistTask', async (data) => {
  const response = await myTaskService.list(data);
  return response;
});

export const patchAssignee = createAsyncThunk(
  'task_routing/fetchAssignee',
  async (data) => {
    const response = await myTaskService.assignee(data);
    return response;
  },
);

export const getUserList = createAsyncThunk(
  'task_routing/fetchUserList',
  async (data) => {
    const response = await myTaskService.userList(data);
    return response;
  },
);

export const myTaskMaintenanceSlice = createSlice({
  name: 'apprv_maintenance',
  initialState: initialState,
  reducers: {
    resetAllData: () => {
      return initialState;
    },
    resetData: (state, action) => {
      const payload = action.payload;
      if (typeof payload === 'string') {
        state[payload] = initialState[payload];
      } else if (Array.isArray(payload)) {
        payload.forEach((item) => (state[item] = initialState[item]));
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getList.pending, (state) => {
        state.statusList = 'loading';
      })
      .addCase(getList.fulfilled, (state, action) => {
        state.statusList = 'success';
        state.data = action.payload;
      })
      .addCase(getList.rejected, (state) => {
        state.statusList = 'error';
      })
      .addCase(getDetail.pending, (state) => {
        state.statusDetail = 'loading';
      })
      .addCase(getDetail.fulfilled, (state, action) => {
        state.statusDetail = 'success';
        state.detailApproval = action.payload;
      })
      .addCase(getDetail.rejected, (state) => {
        state.statusDetail = 'error';
      })
      .addCase(submitTask.pending, (state) => {
        state.statusSubmit = 'loading';
      })
      .addCase(submitTask.fulfilled, (state) => {
        state.statusSubmit = 'success';
      })
      .addCase(submitTask.rejected, (state) => {
        state.statusSubmit = 'error';
      })
      .addCase(getListTask.pending, (state) => {
        state.statusTaskList = 'loading';
      })
      .addCase(getListTask.fulfilled, (state, action) => {
        state.statusTaskList = 'success';
        state.dataTaskList = action.payload;
      })
      .addCase(getListTask.rejected, (state) => {
        state.statusTaskList = 'error';
      })
      .addCase(patchAssignee.pending, (state) => {
        state.statusAssignee = 'loading';
      })
      .addCase(patchAssignee.fulfilled, (state, action) => {
        state.statusAssignee = 'success';
        console.log('status', state.statusAssignee);
      })
      .addCase(patchAssignee.rejected, (state) => {
        state.statusAssignee = 'error';
      })
      .addCase(getUserList.pending, (state) => {
        state.statusUserList = 'loading';
      })
      .addCase(getUserList.fulfilled, (state, action) => {
        state.statusUserList = 'success';
        state.dataUserList = action.payload;
      })
      .addCase(getUserList.rejected, (state) => {
        state.statusUserList = 'error';
      });
  },
});

export const { resetAllData, resetData } = myTaskMaintenanceSlice.actions;

const myTaskMaintenanceReducer = myTaskMaintenanceSlice.reducer;
export default myTaskMaintenanceReducer;